import { color } from "@smartsheet/design-tokens-react";
import { fontWeight } from "./typographyConstants";

/**
 * Font Sizing
 * (includes line height)
 */
export const fontSizeDefinitions = {
    "13": { fontSize: "13px", lineHeight: "18px" },
    "14": { fontSize: "14px", lineHeight: "18px" },
    "15": { fontSize: "15px", lineHeight: "18px" },
    "18": { fontSize: "18px", lineHeight: "24px" },
    "24": { fontSize: "24px", lineHeight: "28px" },
    "32": { fontSize: "32px", lineHeight: "34px" },
    "40": { fontSize: "40px", lineHeight: "48px" },
} as const;

/**
 * Type ramp style definitions
 */
export const typeRampLodestarDefinitions = {
    headlineXLarge: {
        fontWeight: fontWeight.bold,
        fontFamily: "TT Norms Pro",
        color: color("color--text--neutral--strong"),
        ...fontSizeDefinitions["40"],
    },
    headlineLarge: {
        fontWeight: fontWeight.bold,
        fontFamily: "TT Norms Pro",
        color: color("color--text--neutral--strong"),
        ...fontSizeDefinitions["32"],
    },
    headlineMedium: {
        fontWeight: fontWeight.bold,
        fontFamily: "TT Norms Pro",
        color: color("color--text--neutral--strong"),
        ...fontSizeDefinitions["24"],
    },
    headlineSmall: {
        fontWeight: fontWeight.bold,
        fontFamily: "TT Norms Pro",
        color: color("color--text--neutral--strong"),
        ...fontSizeDefinitions["18"],
    },
    headerLarge: {
        fontWeight: fontWeight.semiBold,
        fontFamily: "default",
        color: color("color--text--neutral--default"),
        ...fontSizeDefinitions["15"],
    },
    headerSmall: {
        fontWeight: fontWeight.semiBold,
        fontFamily: "default",
        color: color("color--text--neutral--default"),
        ...fontSizeDefinitions["13"],
    },
    buttonLarge: {
        fontWeight: fontWeight.bold,
        fontFamily: "default",
        color: color("color--text--neutral--default"),
        ...fontSizeDefinitions["14"],
    },
    buttonMedium: {
        fontWeight: fontWeight.semiBold,
        fontFamily: "default",
        color: color("color--text--neutral--default"),
        ...fontSizeDefinitions["13"],
    },
    titlesEmphasis: {
        fontWeight: fontWeight.semiBold,
        fontFamily: "default",
        color: color("color--text--neutral--default"),
        ...fontSizeDefinitions["13"],
    },
    bodyStrong: {
        fontWeight: fontWeight.medium,
        fontFamily: "default",
        color: color("color--text--neutral--default"),
        ...fontSizeDefinitions["13"],
    },
    bodyText: {
        fontWeight: fontWeight.regular,
        fontFamily: "default",
        color: color("color--text--neutral--default"),
        ...fontSizeDefinitions["13"],
    },
    metadata: {
        fontWeight: fontWeight.regular,
        fontFamily: "default",
        color: color("color--text--neutral--weak"),
        ...fontSizeDefinitions["13"],
    },
} as const;
